import colors from '../colors'
import { typography } from '../typography'
export default {
  color: colors.body,
  borderColor: colors.complementary.secondary,
  titleColor: colors.complementary.secondary,
  fontFamily: typography.body.fontFamily
}
